import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const IntroWrapper = styled.div`
  height: 100vh;
  left: 0px;
  position: fixed;
  top: 0px;
  width: 100vw;
  z-index: 1000;
  animation: ${({ loaded }) => (loaded ? 'hide 2.75s' : '')};
  animation-fill-mode: forwards;
  background-color: ${({ theme }) => theme.colors.darkGrey};
  @keyframes hide {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`
const IntroBg = styled.img`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  min-width: 100%;
  object-fit: cover;
`
const ElementWheel = styled.img`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 650px;
`
const ElementsCircle = styled.img`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 600px;
  opacity: 1;
  animation: ${({ loaded }) => (loaded ? 'rotation 1.5s' : '')};
  animation-fill-mode: forwards;
  transform-origin: top left;
  @keyframes rotation {
    0% {
      transform: rotate(0) translate(-50%, -50%);
    }
    100% {
      transform: rotate(360deg) translate(-50%, -50%);
    }
  }
`

const SentipediaIntro = () => {
  const [loaded, setLoaded] = useState(false)
  const [showIntro, setShowIntro] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true)
      setTimeout(() => {
        setShowIntro(false)
        window.sessionStorage.setItem('sentipediaIntroClosed', 'true')
      }, 2750)
    }, 300)
  }, [])
  return (
    showIntro && (
      <IntroWrapper loaded={loaded}>
        <IntroBg
          alt="senti background"
          loaded={loaded}
          src="/images/sentipedia/intro_background.png"
        />
        <ElementWheel
          alt="senti background"
          loaded={loaded}
          src="/images/sentipedia/elements_wheel.png"
        />
        <ElementsCircle
          alt="senti background"
          loaded={loaded}
          src="/images/sentipedia/elements_circle.png"
        />
      </IntroWrapper>
    )
  )
}

export default SentipediaIntro
